import { html } from 'lit';
import { runInAction } from 'mobx';
import comsStore from '../../state/ComsStore';
import { referenceItemTemplate } from './referenceItem.tmpl';
export const referencesTemplate = (references) => {
    const onAddNew = () => {
        runInAction(() => {
            comsStore.references.push({
                type: 'Voice',
                source: 'CCT',
                id: '',
                state: 'inEdit',
            });
        });
    };
    return html `
  <div class="section">
    <div class="container-fluid">
      <h3 class="typography-display--3" style="display: flex; justify-content: space-between;">
        <span>
          Dokumente
        </span>
        <a @click=${onAddNew}>
          Reference hinzufügen
        </a>
      </h3>
      ${references.map((ref) => referenceItemTemplate(ref))}
      </div>
    </div>
  </div>
`;
};
//# sourceMappingURL=references.tmpl.js.map